import type { FormPage, FormQuestion } from "../../types/form.types";

export interface EmptyQuestion {
  pageIndex: number;
  pageName: string;
  sectionId: string;
  sectionName: string;
  /** Top-level question to select; for a nested field, its group. */
  questionId: string;
  typeName: string;
}

/** A question of only spaces reads as blank to the person filling the form. */
export const isEmptyQuestion = (q: Pick<FormQuestion, "question">) => !q.question?.trim();

export const findEmptyQuestions = (pages: FormPage[]): EmptyQuestion[] =>
  pages.flatMap((page, pageIndex) =>
    page.sections.flatMap((section) =>
      section.questions.flatMap((question) =>
        [question, ...(question.fields ?? [])].filter(isEmptyQuestion).map((q) => ({
          pageIndex,
          pageName: page.name,
          sectionId: section.id,
          sectionName: section.name,
          questionId: question.id,
          typeName: q.typeName,
        })),
      ),
    ),
  );
